module.exports = __webpack_public_path__ + "static/media/event-services-img30.df5acf8a.jpg";